import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../config/api';
import { CREATE_BUDGET_AT_CLIENT_STEP_PATH } from '../../../contants';
import {
  MONTHLY_OPTIONS,
  TYPE_OPTIONS,
  WEEKLY_OPTIONS,
} from '../../../contants/createBudget';
import {
  addFormData,
  changeChoosenAccounts,
  changeChoosenCampaigns,
  changeChoosenSources,
  changeTab,
} from '../../../features/createBudget/createBudgetSlice';
import { notyfError } from '../../../helpers/notyf';

export const useBudget = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { formData, isUpdateBudget } = useSelector(
    state => state.createBudget,
  );

  const [isLoading, setIsLoading] = useState(false);
  const [accountIds, setAccountIds] = useState([]);

  useEffect(() => {
    const fetchBudgetData = async () => {
      if (params.id && !isNaN(params.id) && isUpdateBudget) {
        setIsLoading(true);

        try {
          const data = await api.GET_BUDGET(params.id);
          let dataToSet = {
            ...formData,
            id: +data.id,
            amount: +data.amount,
            name: data.name,
            google_budget: data.google_budget,
            type: data.type,
            client: { value: data.client.id, label: data.client.name },
            renew_type: data.renew_type,
          };

          if (data.month_start_day) {
            dataToSet.month_start_day = MONTHLY_OPTIONS.find(
              opt => +opt.value === +data.month_start_day,
            );
          }

          if (data.week_start_day) {
            dataToSet.week_start_day = WEEKLY_OPTIONS.find(
              opt => +opt.value === +data.week_start_day,
            );
            dispatch(changeTab('weekly'));
          }
          if (data.start_date && data.end_date) {
            dataToSet.renew_type = TYPE_OPTIONS.find(
              opt => opt.label === data.renew_type,
            );
            dataToSet.start_date = data.start_date;
            dataToSet.end_date = data.end_date;
            dispatch(changeTab('custom'));
          }

          dispatch(addFormData({ ...dataToSet }));

          const accounts = data?.campaigns.map(campaign => campaign?.account);
          const uniqueAccounts = accounts?.filter(
            (account, index, self) =>
              index ===
              self.findIndex(_account => _account?.id === account?.id),
          );

          if (uniqueAccounts.length === 1) {
            dispatch(changeChoosenAccounts(uniqueAccounts));
            dispatch(changeChoosenSources([uniqueAccounts[0]?.source]));
          }

          setAccountIds(uniqueAccounts.map(account => account?.id));
          dispatch(changeChoosenCampaigns(data.campaigns));
        } catch (err) {
          const { response } = err;
          if (response?.status === 404) {
            notyfError("Budget isn't existed");
            navigate(CREATE_BUDGET_AT_CLIENT_STEP_PATH, { replace: true });
          }
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchBudgetData();
  }, [params.id, isUpdateBudget]);

  return {
    isLoading,
    accountIds,
  };
};
